import React from 'react';

const FutureFocused = () => {
  return (
    <section className="section-container section-future">
      <div className="future-content">
        <h2 className="future-headline">
          This is how investing will feel in the next decade.
        </h2>
        <p className="future-subtext">
          Finance doesn't need to be complicated.
        </p>
      </div>
    </section>
  );
};

export default FutureFocused;
